export const projectStatusTypes = {
    TREINAMENTO: "treinamento",
    HOMOLOGACAO: "homologação"
  };